<!--

Component is used when navigation is needed. Style of the button can be modified in multiple options. Check slots and props below for details.

Slots:
  - default : Anything you provide in the component body will be shown inside "button-content" slot instead the default provided in the component.
              You can pass complex HTML structure if needed.

Props:
  -

-->

<template>
  <b-dropdown
    no-caret
    right
    no-flip
    toggle-class="dropdown-menu-toggle"
    menu-class="menu-items offset-down"
    class="sb-dropdown-menu business-menu"
    :class="{'auto-width': autoWidth, 'auto-height': autoHeight, 'no-hover-box': noHover}"
    @click.native.stop="">
    <!-- Button content -->
    <template slot="button-content">
      <slot>
        <span class="sb-dropdown-menu-button"/>
      </slot>
    </template>
    <!-- Header on the menu items -->
    <b-dropdown-header>
      <span class="data">
        <p class="title">{{ organisation.name }}</p>
      </span>
    </b-dropdown-header>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'Organisation', params: { organisationId: organisation.id }}"
    >
      <span class="icon inbox"/>
      <span class="text">Inbox</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item>
      <span class="icon broadcasts"/>
      <span class="text">Broadcasts *</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'Automation', params: { merchant_id: 'todo'}}">
      <span class="icon automation"/>
      <span class="text">Automation</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'Contacts', params: { merchant_id: 'todo'}}">
      <span class="icon contacts"/>
      <span class="text">Contacts</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item>
      <span class="icon sources"/>
      <span class="text">Sources *</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'Analytics', params: { merchant_id: 'todo'}}">
      <span class="icon analytics"/>
      <span class="text">Analytics</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item>
      <span class="icon integrations"/>
      <span class="text">Integrations *</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item>
      <span class="icon developers"/>
      <span class="text">Developers *</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item
      :to="{ name: 'BusinessSettings', params: { merchant_id: 'todo'}}">
      <span class="icon settings"/>
      <span class="text">Settings</span>
    </b-dropdown-item>
    <b-dropdown-divider/>
    <!-- Footer on the menu items -->
    <b-dropdown-text class="sb-dropdown-menu-footer">
      Need help? Chat with us.
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
// import { mapActions, mapGetters } from 'vuex';
import BusinessDropdownTypes from '../../helpers/lists/businessDropdownTypes';

export default {
  name: 'OrganisationDropdown',
  components: {
  },
  props: {
    /**
     * Org for which the button is generated.
     */
    organisation: {
      type: Object,
      required: true,
    },
    /**
     * Button is by default restricted to a 40px square. This param will make the with addoptable to content.
     * TODO... see if this can be achieved with css only for the default tridots button.
     */
    autoWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Unlocks height to be addoptable to content.
     */
    autoHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * There is a default hover state on the button. It can be toggled with this prop.
     */
    noHover: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * TODO see if it will be needed or not...
     */
    buttonStyle: {
      type: String,
      default: BusinessDropdownTypes.ICON,
    },
  },
  data() {
    return {
      BusinessDropdownTypes,
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.business-menu {
  width: 32px !important;
  height: 18px !important;
  margin-right: 9px!important;

  &.auto-width {
    width: auto !important;
  }

  &.auto-height {
    height: auto !important;
  }

  .location {
    font-size: 16px;
    font-weight: 500;
  }

  .left-icon {
    margin-right: 8px !important;
  }

  .right-icon {
    width: 11px !important;
    height: 6px !important;
    margin-left: 8px !important;
    margin-right: 0 !important;
  }

  ::v-deep .dropdown-menu-toggle {
    background: red;
    box-shadow: none !important;
  }
}
</style>
